// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1423":"58675f78","2347":"58675f78"}[chunkId] + ".chunk.css";
};